import classNames from 'classnames';
import { useMemo } from 'react';
import { clamp } from '/src/utils/math';

export const sliderWidth = 21;

export function Slider({ currentPosition = 0, timelineWidth = 0, isDragging = false, didSeek = false }) {
  const memoizedPosition = useMemo(() => {
    return clamp(
      currentPosition * timelineWidth - sliderWidth / 2,
      0 - sliderWidth / 2,
      timelineWidth - sliderWidth / 2,
    );
  }, [currentPosition, timelineWidth]);

  if (!timelineWidth) return null;

  const common =
    'drag-handle absolute bottom-0 top-0 z-30 m-auto flex h-5 w-5 cursor-pointer items-center justify-center rounded-full bg-white shadow-xl outline-none hover:scale-125 will-change-transform';

  return (
    <div
      className={classNames(
        common,
        isDragging || didSeek ? 'transition-none' : 'transition-transform ease-linear duration-1000',
      )}
      style={{ transform: `translate3d(${memoizedPosition}px,0,0)`, zIndex: 150 }}
    >
      <span className="block h-3 w-3 select-none rounded-full bg-dodger-blue-500"></span>
    </div>
  );
}
